import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Store.css';

class Store extends Component {
  render() {
    return (
      <div className="Store" ref={div => (this.appContainer = div)}>
        <Header />
        <div className="Rooms-container">
          <div className="Content-top"></div>
          <div className="Content-mid">
            <div className="Content-header">STORE</div>
          </div>
          <div className="Content-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Store;
